import {disp_xhr_error, remove_xhr_form_error, truncate_string_with_ellipsis } from './ui_tweak.js';
import {formatHelper } from './file_size_formatter.js';
import select2 from 'select2';
import i18n from './i18n_js_with_locales';

select2(window, $);  // To select2 bind to $

var ResumeMgmt = (function(){

    var folders_data = null;

    function init_folders_treegrid(){
	$("#dest-folders").on("mousedown", "tr", function() {
	    $(".selected").not(this).removeClass("selected");
	    $(this).toggleClass("selected");
	});
    }

    function get_checked_items(box_name){
	return $("#folder-content input[name='"+box_name+"']:checked").map(function() { return this.value; }).get();
    }

    function add_folder_node_line(id, parent_id, name, long_desc){
	var desc = truncate_string_with_ellipsis(long_desc ||'', 32);
	if (parent_id) {
	    $("<tr></tr>").addClass("treegrid-"+id).addClass("treegrid-parent-" + parent_id).appendTo($('#dest-folders tbody')).html("<td>"+name+"</td><td>" + (desc || '') + "</td>");
	}else{
	    $("<tr></tr>").addClass("treegrid-"+id).appendTo($('#dest-folders tbody')).html("<td>"+name+"</td><td>" + (desc || '') + "</td>");
	}
    }

    function add_folder_node(node, parent_id){
	add_folder_node_line(node.id, parent_id, node.name, node.desc);
	for(var i = 0; i< node.children.length; i++){
	    add_folder_node(node.children[i], node.id)
	}
    }

    function show_dest_folder_choices()
    {
	if (!folders_data){
	    $.ajax("/resume_folders.json").done(function(data) {
		folders_data = data;
		if (data){
		    add_folder_node(data, null);
		    $('#dest-folders').treegrid();
		}
	    });
	}
	$('#folders-modal').modal();
    }

    function init_move_button(){
	$('#resume-move-btn').click(function(e) {
	    e.preventDefault();

	    var selected_folders = get_checked_items("folder_ids[]");
	    var selected_files   = get_checked_items("file_ids[]");
	    $('#target_folder_id').val('');
	    if (selected_folders.length > 0 || selected_files.length > 0) {
		show_dest_folder_choices();
	    }else{
		alert("Please select folders or files first.");
	    }
	});
    }

    function init_confirm_move_btn(){
	$('#resume-confirm-move').click(function(e) {
	    var dest_folder_id;
	    var tr_selected = $("#dest-folders tr.selected");
	    if (tr_selected.length > 0){
		tr_selected = tr_selected[0];
		dest_folder_id = $(tr_selected).treegrid('getNodeId');
	    }
	    if (dest_folder_id && dest_folder_id != $('#current_folder_id').val()) {
		$('#target_folder_id').val(dest_folder_id);
		$('#move-form').submit();

	    }else{
		alert('Please choose a correct folder.');
	    }
	});
    }

    function init_add_talent_in_line(){
    	 $('.add-talent-in-line').click(function(){
	     var node = $(this);
	     popup_add_talent_for_resume(node.data("target"));
	 });

	$('.add-line-talent #new_talent_ajax').on("ajax:success", function(e){
	    const [data, status, xhr] = e.detail;
	     update_talent_link(data);
	     $('#adding_talent').modal('hide');
	}).on("ajax:error", function(e){
	    const [data, status, xhr] = e.detail;
	     if (xhr.status == 404) {
		 alert('Sorry, something went wrong. Please try again');
		 window.location.reload(true);
	     }else{
		 disp_xhr_error(this, xhr );
	     }
	 });
    }

    function popup_add_talent_for_resume(resume_id){
	var form = $('#adding_talent form');

	form.trigger("reset");
	remove_xhr_form_error(form);

	$('#adding_talent #resume_id').val(resume_id);
	popup_add_talent_with_name('');
    }

    function update_talent_link(talent){
	var resume_id = $('#adding_talent #resume_id').val();
	if (!resume_id) return;

        var link = $("a.add-talent-in-line[data-target="+ resume_id +"]");
	link.text(talent.first_name + ' ' + talent.last_name);
	link.prop("href", "/talents/"+ talent.talent_id);
	link.removeClass("add-talent-in-line");

	$("a.add-talent-in-line[href='/documents/" + resume_id + "/edit']").hide();
    }

    return {
	init_folders_treegrid: init_folders_treegrid,
	init_confirm_move_btn: init_confirm_move_btn,
	init_resumes_move_button: init_move_button,

	init_add_talent_in_line: init_add_talent_in_line,    //for search page and index page
    };
})();


function update_progress_bar(file){
    var line = $('#'+ file.unique_id);
    if (file.resume_id) {
	line.find('.progress').removeClass("progress-striped active");
	line.find('.size').text(formatHelper.formatFileSize(file.file_size));
	if (file.owner_id) line.find('.name span.badge').removeClass("fade");
    }else{
     	line.find('.size').text("Failed. "+ file.error_msg);
	line.find('.progress-bar').addClass('progress-bar-warning');
    }
}

// ------- resume edit page -------

function talentFormatResult(talent) {
    if (talent.loading) return talent.text;

    var markup = "<div>";
    markup += "<b>"+ talent.first_name + ' ' + talent.last_name + "</b>  &nbsp; ";
    markup += "<span>&lt;" + talent.email + "&gt;</span>";
    markup += "</div>";
    return markup;
}

function talentFormatSelection(item) {
    if (item.first_name){
	return item.first_name + ' ' + item.last_name + '  &lt;' + item.email + '&gt;'
    }else{
	return item.text.replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
}

function popup_add_talent_with_name(name){
    $('#adding_talent #talent_first_name').val(name);
    $('.select2-dropdown').css('z-index',1000);
    $('#adding_talent').modal();
}

function no_talent_found(name){
    var query  = $("body .select2-search").find("[aria-controls='select2-resume-talent-id-select-results']").val();
    return "No Results Found?, <a href='#' class='popup_add_talent_link' data-target='" + query + "'>Create now?</a>";
}

function init_resume_talent_id_select2(){
    $('#resume-talent-id-select').select2({
	minimumInputLength: 0,
	allowClear: true,
	placeholder: 'Please choose... ',
	ajax: {
	    url: "/talents/ajax_list",
	    data: function (params) {
		return {
		    q: params.term, // search term
		    page: params.page,
		    page_limit: 20
		};
	    },
	    processResults: function (data, params) {
		params.page = params.page || 1;
		var more = (params.page * 20) < data.total_count;
		return {results: data.items, pagination: {more: more}};
	    }
	},
	templateResult: talentFormatResult,
	templateSelection: talentFormatSelection,
	language: { noResults: no_talent_found },
	escapeMarkup: function (m) { return m; }
    });
}

function update_talent_dropdown(json){
    var option = $("<option></option>");
    option.val(json.talent_id);
    option.text(json.first_name + '  ' + json.last_name + ' &lt;' + json.email + '&gt;');
    $('#resume-talent-id-select').prepend(option);
    $('#resume-talent-id-select').val(json.talent_id).change();
}

function disable_submit_btn() { $('#new_applicant :input[type="submit"]').prop('disabled', true ); }
function enable_submit_btn()  { $('#new_applicant :input[type="submit"]').prop('disabled', false); }

function bind_event_for_ajax_add_talent_when_editing_resume(){
    	 $('.resume-edit #new_talent_ajax').on("ajax:success", function(e){
	     const [data, status, xhr] = e.detail;

	     update_talent_dropdown(data);
	     $('#adding_talent').modal('hide');
	 }).on("ajax:error", function(e){
	     const [data, status, xhr] = e.detail;
	     if (xhr.status == 404) {
		 alert('Sorry, something went wrong. Please try again');
		 window.location.reload(true);
	     }else{
		 disp_xhr_error(this, xhr );
	     }
	 });
}

function bind_event_for_s3_uploader_form(form_id){
     $(form_id)
        .on('ajax:beforeSend', function(e, data){ disable_submit_btn(); })
        .on('ajax:complete',   function(e, data){ enable_submit_btn(); })
        .on('ajax:success',    function(e, data){
	    if (data.resume_id) {
		$('#resume_id').val(data.resume_id);
		update_progress_bar(data);
	    }})
        .on('ajax:error',      function(e, error_data) {
	    const xhr = error_data;
	    alert(i18n.t('resumes.new.upload_failed')+ ': '+ xhr.responseText);
	 })
	.on('s3_uploads_start',    function(e, data) { disable_submit_btn(); })
	.on('s3_uploads_complete', function(e, data) { enable_submit_btn(); });
}

function bind_event_for_uploader_form(){
    bind_event_for_s3_uploader_form('#uploader-form');
    bind_event_for_s3_uploader_form('#batch-uploader-form');
}

function init_s3_direct_uploader(form_id, allow_multiple){
    $(form_id).FilesUploader({
	set_additional_data: compose_additional_data,
	allow_multiple_files: allow_multiple,
	progress_bar_target: form_id + ' tbody.files',
	remove_completed_progress_bar: false,
	before_add: function(file) {
	    if (file.size > 10*1024*1024) {
		alert("Maximum file size is 10 MB");
		return false;
	    }
	    return true;
	}
    });
}

function init_batch_uploader_form(){
    init_s3_direct_uploader('#batch-uploader-form', true);
    init_s3_direct_uploader('#uploader-form', false);
}

function compose_additional_data(){
    var page_data = $('.ruby-to-js').data('resume-info');

    if ($('.resume-upload input[name="private_record"]').length) {
	const private_flag = $('.resume-upload input[name="private_record"]:checked').val();
	Object.assign(page_data, { private_record: private_flag });
    }
    return page_data;
}

function init_pop_add_talent_link(){
    $(document).on('click', 'a.popup_add_talent_link', function(e){
	var node = $(this);
	popup_add_talent_with_name(node.data('target'));
    });
}

$(document).ready(function(){
    init_batch_uploader_form();
    ResumeMgmt.init_add_talent_in_line();
    init_resume_talent_id_select2();
    init_pop_add_talent_link();
    bind_event_for_ajax_add_talent_when_editing_resume();
    bind_event_for_uploader_form();

    ResumeMgmt.init_folders_treegrid();       //resumes index.html.erb
    ResumeMgmt.init_resumes_move_button();    //resumes index.html.erb
    ResumeMgmt.init_confirm_move_btn();       //resumes index.html.erb
});
